import { useMutation } from 'react-query';

import { getAiTaskMitigation as mutationFn } from 'api/endPoints/getAiTaskMitigation';

export const useMutationGenerateMitigation = () => {
    return useMutation<
        {
            mitigation: string;
            taskId: number;
        },
        QueryError,
        {
            taskId: number;
            laneId: string | number;
            isVirtual: boolean;
            cardId: number | null;
            versionId: number;
        }
    >((params) => mutationFn(params));
};
